import React from 'react';
import Seo from '../components/common/Seo';
import PageHero from '../components/common/PageHero';
import ContactForm from '../components/common/ContactForm';
import { contact } from '@/data/contact';
import { seo } from '@/data/seo';

const Careers = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      <Seo {...seo.careers} />
      <PageHero
        eyebrow="Careers"
        title="It is a pleasure"
        highlight="to receive your message"
        description="MAYAN Technology welcomes messages from engineers, technicians, and skilled professionals. There are no open roles listed publicly — send your details and we will be in touch if there is a match."
      />

      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white border border-gray-200 rounded-2xl p-8 md:p-12">
            <p className="text-gray-600 mb-8">
              You can also email {contact.email} directly. If you have a CV, please attach it when your email client opens.
            </p>
            <ContactForm variant="careers" idPrefix="careers" submitLabel="Send application" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
